export const INHERIT_QR = 'https://cdn.vip-wifi.com/fangchan/img/personal_package/inherit/qr.png'
export const DORA_QR = 'https://cdn.vip-wifi.com/fangchan/img/personal_package/dora/qr.png'